import React, { useEffect } from "react";
import { EditTwoTone } from "@ant-design/icons";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import useMachineForm from "./useMachineForm"; // Adjust path as necessary
import { updateMachine, fetchMachines } from "../../../redux/Machine/actions";
import { fetchCountries } from "../../../redux/Country/actions";
import MachineForm from "./MachineForm";

export const EditMachineButton = ({ item, users }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const countries = useSelector((state) => state.countries?.countries || []);

  const {
    form,
    visible,
    showModal,
    hideModal_Ok,
    hideModal_Cancel,
    form_onFinish,
  } = useMachineForm(
    {
      machinename: item.machinename || '',
      machineid: item.machineid || '',
      user: item.user ? item.user._id : null,
      country: item.country || '',
      islinkedPC: item.islinkedPC || false,
      idpc: item.idpc || '',
      keypc: item.keypc || '',
      isActive: item.isActive !== undefined ? item.isActive : true,
    },
    (values) => {
      dispatch(updateMachine(item._id, values)).then(() => {
        dispatch(fetchMachines()); // Refetch machines after update
      });
    },
    'edit'
  );

  useEffect(() => {
    if (visible && item) {
      form.setFieldsValue({
        machinename: item.machinename,
        machineid: item.machineid,
        user: item.user ? item.user._id : null,
        country: item.country,
        islinkedPC: item.islinkedPC,
        idpc: item.idpc,
        keypc: item.keypc,
        isActive: item.isActive,
      });
    }
  }, [visible, item, form]);

  return (
    <>
      <EditTwoTone onClick={showModal} />
      <Modal
        title="Edit Machine"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Save"
        cancelText="Cancel"
      >
        <MachineForm form={form} users={users} countries={countries} onFinish={form_onFinish} />
      </Modal>
    </>
  );
};

export default EditMachineButton;
